import { defineStyleConfig } from '@chakra-ui/react';

export const InputStyle = defineStyleConfig({
  sizes: {
    lg: {
      field: {
        fontSize: 'md',
        h: '62px',
      },
    },
    md: {
      field: {
        fontSize: 'md',
        h: '46px',
      },
    },
  },
});
